import { createContext, useEffect, useState } from 'react';
import Login from '../pages/login/Login';
import { isLogged } from '../service/Auth.service';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuth, setAuth] = useState(undefined);

  useEffect(() => {
    const checkLoggedIn = async () => {
      let auth = isLogged();

      if (auth) {
        setAuth(true);
      } else {
        setAuth(false);
      }
    };

    checkLoggedIn();
  }, []);

  return (
    <AuthContext.Provider value={[isAuth, setAuth]}>
      {isAuth ? children : <Login />}
    </AuthContext.Provider>
  );
};

export default AuthContext;
